export const CORE_PACKAGES_WORKFLOW_KEYS = {
	ACTIVE: 'ACTIVE',
	WAITING: 'WAITING',
	IN_ACTIVE: 'IN_ACTIVE',
};

export const CORE_PACKAGES_WORKFLOW_LABELS = {
	ACTIVE: 'فعال',
	WAITING: 'در انتظار تایید',
	IN_ACTIVE: 'غیر فعال',
};

export const CORE_PACKAGES_WORKFLOW_STATES = {
	ACTIVE: ['synced'],
	WAITING: [
		'new',
		'signed',
		'assigned',
		'completed',
		'incompleted',
		'approved',
	],
	IN_ACTIVE: ['rejected', 'spam'],
};
